import { render, staticRenderFns } from "./DownloadSlideSection.vue?vue&type=template&id=4b790ecf&scoped=true"
import script from "./DownloadSlideSection.vue?vue&type=script&lang=js"
export * from "./DownloadSlideSection.vue?vue&type=script&lang=js"
import style0 from "./DownloadSlideSection.vue?vue&type=style&index=0&id=4b790ecf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b790ecf",
  null
  
)

export default component.exports